import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const sparkleConfig: TSPConfig = {
  key: 'sparkle',
  name: 'Sparkle',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from Sparkle support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default sparkleConfig;
